import { render } from "./SocialHooksDashboard.vue?vue&type=template&id=f160925e&scoped=true"
import script from "./SocialHooksDashboard.vue?vue&type=script&lang=js"
export * from "./SocialHooksDashboard.vue?vue&type=script&lang=js"

import "./SocialHooksDashboard.vue?vue&type=style&index=0&id=f160925e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f160925e"]])

export default __exports__